// src/components/ui/ProfilePreviewModal.js
// Apercu "public" d'un profil (marchand ou admin) : banniere de couverture
// + photo/logo + nom, tel qu'il apparait aux visiteurs. Modale fermable
// (bouton X, clic sur le fond, touche Echap). react-icons, aucun emoji.
// Maxula

import React, { useEffect } from 'react';
import { FiX, FiEye } from 'react-icons/fi';

export default function ProfilePreviewModal({
  open, onClose, coverUrl, logoUrl, name, subtitle,
  logoShape = 'full', // 'full' (cercle) | 'xl' (arrondi)
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);

  if (!open) return null;

  const radius = logoShape === 'xl' ? 'rounded-2xl' : 'rounded-full';
  const initial = String(name || '?').trim().charAt(0).toUpperCase() || '?';

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/60"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-lg bg-white rounded-2xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-gray-700">
            <FiEye /> Apercu de votre profil public
          </span>
          <button type="button" onClick={onClose} aria-label="Fermer" className="text-gray-400 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100">
            <FiX size={20} />
          </button>
        </div>

        <div className="p-5">
          <div className="rounded-2xl border border-gray-200 overflow-hidden">
            <div
              className="h-36 w-full bg-gray-100"
              style={!coverUrl ? { background: 'linear-gradient(135deg,#E11D79 0%,#FF3D9A 55%,#FF77BC 100%)' } : undefined}
            >
              {coverUrl ? (
                <img src={coverUrl} alt="" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
              ) : null}
            </div>
            <div className="px-5 pb-5">
              <div className={`-mt-10 w-20 h-20 ${radius} bg-white p-1 shadow-md inline-flex`}>
                <div className={`w-full h-full ${radius} bg-gray-100 overflow-hidden flex items-center justify-center`}>
                  {logoUrl
                    ? <img src={logoUrl} alt="" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                    : <span className="text-2xl font-bold text-gray-300">{initial}</span>}
                </div>
              </div>
              <h3 className="mt-3 text-xl font-bold text-gray-900 truncate">{name || 'Votre nom'}</h3>
              {subtitle ? <p className="text-sm text-gray-500 truncate">{subtitle}</p> : null}
            </div>
          </div>
          <p className="mt-3 text-xs text-gray-400 text-center">
            Apercu indicatif. Les images non encore enregistrees sont aussi affichees.
          </p>
        </div>
      </div>
    </div>
  );
}
